export function ccyFormat(num) {
    return "€" + Number(num).toFixed(2);
};

export function formatPrice(price) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR"
    });
    return formatter.format(price);
}
